export default function ImageUploadController($stateParams, $state, merchantImagesService, FileUploader, NotificationService, HTTP_CODE) {
  var vm = this;

  vm.isLoading = false;
  vm.merchantId = $stateParams.merchantId;
  vm.uploader = new FileUploader();
  vm.errorMessages = [];
  vm.imageFile = null;
  vm.imageData = {
    name: null,
    type: null,
    sortOrder: 0,
  };

  vm.uploadImage = uploadImage;

  vm.uploader.onAfterAddingFile = function(fileItem) {
    vm.imageFile = fileItem._file;
  };

  function uploadImage() {
    if (!vm.imageFile || vm.isLoading) {
      return;
    }

    vm.errorMessages = [];
    vm.isLoading = true;
    merchantImagesService
      .uploadImage(vm.merchantId, vm.imageData, vm.imageFile)
      .then(function redirectToMerchantView() {
        $state.go(
          'app.merchant',
          {
            merchantId: vm.merchantId,
            tab: 'images',
          },
          { reload: true },
        );
      })
      .catch(handleUploadFail)
      .finally(function() {
        vm.isLoading = false;
      });
  }

  function handleUploadFail(res) {
    var msg = '';
    if (res.status === HTTP_CODE.STATUS.BAD_REQUEST) {
      msg = 'Error uploading image to S3. Check error messages table at the bottom of the page';
      parseErrorResponse(res.data.errors);
    }
    if (res.status === HTTP_CODE.STATUS.INTERNAL_SERVER_ERROR) {
      msg = 'Error uploading image to S3. Failed connection';
    }
    NotificationService.error(msg);
  }

  function parseErrorResponse(errors) {
    var errorResponseMessages;

    if (!(errors && errors.length)) {
      return;
    }

    errorResponseMessages = errors.map(function(row) {
      return row.message;
    });
    vm.errorMessages = errorResponseMessages;
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/images/image-upload.controller.js